import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import { trackDemoRedirect } from './demo.analytics';
import ab from 'src/replicant/ruleset/ab';
import { getOpenWebGameURL } from 'src/replicant/utils/payload';
import { Feature } from 'src/replicant/analytics';
import StateObserver, { user } from 'src/StateObserver';
import { getDemoFirstEntryInfo, getDemoState } from 'src/lib/getDemoState';

/**
 * Redirect to line open web game
 */
export function lineLoginFromDemo() {
  trackDemoRedirect(
    getDynamicTestBucket(user(), ab.tests.TEST_DEMO_MODE) || undefined,
  );

  // retrieve first entry info
  const firstEntryInfo = getDemoFirstEntryInfo();
  const demoState = getDemoState();

  location.href = getOpenWebGameURL(
    {
      feature: Feature.OPEN_WEB_DEMO._,
      $subFeature: Feature.OPEN_WEB_DEMO.REDIRECT,
      $channel: firstEntryInfo?.$channel,
      $adNetworkName: firstEntryInfo?.$adNetworkName,
      $adCampaignName: firstEntryInfo?.$adCampaignName,
      $adSetName: firstEntryInfo?.$adSetName,
      $adCreativeName: firstEntryInfo?.$adCreativeName,
    },
    {
      locale: StateObserver.getLocale(),
      demoPayload: demoState,
    },
  );
}
